import React from "react";
import ReactDOM from "react-dom/client";
import { Helmet } from "react-helmet";
import PasswordGenerator from "PasswordGenerator";
import "index.css";
import "reset.css";

document.title = "Password Generator | Frankerator";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="wrapper container">
      <PasswordGenerator />
    </div>
  </React.StrictMode>
);
